import { api } from "../lib/api";

/** AnalyticsEngine: enriches attempts with pain/fatigue context and ships them to Baobab Care (with retry queue). */
export class AnalyticsEngine {
  constructor(sessionId, inputSource) {
    this.sessionId = sessionId;
    this.inputSource = inputSource;
    this.queueKey = `baobab.queue.${sessionId}`;
    this.context = { pain_reported: null, fatigue_reported: null };
    this.local = [];
  }

  setReported(pain, fatigue) { this.context = { pain_reported: pain, fatigue_reported: fatigue ?? this.context.fatigue_reported }; }

  async record(attempt) {
    const full = { ...attempt, ...this.context, input_source: this.inputSource };
    this.local.push(full);
    try {
      await this.flush();
      await api.post(`/sessions/${this.sessionId}/attempts`, full);
    } catch {
      const q = JSON.parse(localStorage.getItem(this.queueKey) || "[]");
      localStorage.setItem(this.queueKey, JSON.stringify([...q, full]));
    }
  }

  async flush() {
    const q = JSON.parse(localStorage.getItem(this.queueKey) || "[]");
    for (const a of q) await api.post(`/sessions/${this.sessionId}/attempts`, a);
    localStorage.removeItem(this.queueKey);
  }

  forMission(key) { return this.local.filter((a) => a.mission_key === key); }
}
